import { EdgeState } from './edge.types';

import { RootState } from '~/redux/store';

export const selectIsApplySameEdgeActive = ({
  edge,
}: RootState): EdgeState['isApplySameEdgeActive'] => edge.isApplySameEdgeActive;

export const selectUserSelectedEdge = ({
  edge,
}: RootState): EdgeState['userSelectedEdge'] => edge.userSelectedEdge;
